import {styled} from '@mui/material/styles'
import Link from '@mui/material/Link'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import {Popover, Typography} from '@mui/material'

export const StyledLink = styled(Link)(({theme}) => ({
  textDecoration: 'none',
  cursor: 'pointer',
  color: theme.palette.hpPrimary,
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledBreadcrumbs = styled(Breadcrumbs)(({theme}) => ({
  marginBottom: theme.spacing(1.75)
}))

export const StyledBreadcrumbPopover = styled(Popover)(() => ({
  pointerEvents: 'none'
}))

export const StyledBreadcrumbPopoverContent = styled(Typography)(({theme}) => ({
  padding: theme.spacing(1),
  maxWidth: '300px',
  whiteSpace: 'normal',
  overflowWrap: 'break-word'
}))
